export const getElemApp = () => document.querySelector('#pm-app')

export const getElemSiteHeader = () => document.querySelector("#site-header")

export const getElemSiteFooter = () => document.querySelector("#site-footer")

export const getElemsShortcode = () => Array.from(document.querySelectorAll(".pm-shortcode-program"))

export const getElemFireplaceAdvertisement = () => document.querySelector("#fireplace-wrapper")

export const getElemFireplaceAdvertisementSmall = () => document.querySelector("#fireplace-wrapper-small")